export class SettingsDto {
  settingName: string;
  settingValue: string;
}
